import { render, staticRenderFns } from "./multiMetaData.vue?vue&type=template&id=4bcbd3bc&scoped=true"
import script from "./multiMetaData.vue?vue&type=script&lang=js"
export * from "./multiMetaData.vue?vue&type=script&lang=js"
import style0 from "./multiMetaData.vue?vue&type=style&index=0&id=4bcbd3bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcbd3bc",
  null
  
)

export default component.exports